import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2, _path3, _defs;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgMenuzen = function SvgMenuzen(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M11.572.438C5.575 1.133.613 4.711.613 12.426.61 20.083 6.306 23.658 12.868 23.672c6.575.013 15.877-7.27 10.037-18.075C19.52-.664 11.572.438 11.572.438Z",
      fill: "#fff"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M11.572.438C5.575 1.133.613 4.711.613 12.426.61 20.083 6.306 23.658 12.868 23.672c6.575.013 15.877-7.27 10.037-18.075C19.52-.664 11.572.438 11.572.438Z",
      fill: "url(#menuzen_svg__a)"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.262 13.692c3.064-.818 4.206.478 1.697 2.018-1.947 1.196-4.18 1.74-6.732 1.54-2.509-.197-4.62-.695-6.502-2.165-1.085-.848-.918-1.7.602-1.343 3.34.785 7.564.852 10.935-.05ZM16.57 9.696c1.237-.334 1.872.301.81 1.086-2.47 1.824-5.256 3.144-9.015 1.748-1.326-.495-1.376-1.654.538-1.741 2.663-.124 5.205-.424 7.668-1.093ZM14.917 6.866c1.938.485 1.7 1.928.357 2.122-1.44.207-4.487.043-5.85-.748-.962-.558-.003-1.18 1.353-1.26 1.64-.097 2.977-.404 4.14-.114Z",
      fill: "#fff"
    })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "menuzen_svg__a",
        x1: 0.613,
        y1: -6.004,
        x2: 22.893,
        y2: 29.191,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FFC2AE"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#A655D8"
        })]
      })
    }))]
  }));
};
export default SvgMenuzen;